// extracted by mini-css-extract-plugin
export default {"styles":"styles___j0UJ1","FFeather":"FFeather___SpY05"};